import {
  NumericTextBox,
  NumericTextBoxChangeEvent,
  TextBoxChangeEvent,
} from "@progress/kendo-react-inputs";
import { useEffect, useRef, useState } from "react";
import ErrorMessage from "../global/ErrorMessage";
import CustomLabel from "../global/RequiredMark";

interface IProps {
  name: string;
  value: number | undefined;
  required: boolean;
  label: string;
  placeholder: string;
  disabled: boolean;
  onChange: (e: TextBoxChangeEvent | NumericTextBoxChangeEvent) => void;
  onValidate: (name: string, isValid: boolean) => void;
  flexDir?: string;
}

function BBSNumberField({
  name,
  value,
  required,
  label,
  placeholder,
  disabled,
  flexDir,
  onChange,
  onValidate,
}: IProps) {
  const valueChanged = useRef(false);
  const [isValid, setIsValid] = useState(true);
  const [dirty, setDirty] = useState(false);

  const handleChange = (e: NumericTextBoxChangeEvent) => {
    valueChanged.current = true;
    const input = e.target.value;

    let valid = true;
    if (input === null) {
      valid = true;
    } else if (input !== null && input > -1) {
      valid = true;
    } else {
      valid = false;
    }

    if ((input === null || input === undefined) && !required) {
      setIsValid(true);
      onValidate(name, valid);
    } else {
      setIsValid(valid);
      onValidate(name, valid);
    }
    onChange(e);
  };

  useEffect(() => {
    if (required && !value && valueChanged.current === false) {
      onValidate(name, false);
    }
  }, [value, required]);

  return (
    <div className={flexDir === "row" ? "flex gap-x-4" : ""}>
      {label && label != "" && (
        <CustomLabel
          label={label}
          required={disabled ? false : required}
          flexDir={flexDir}
        />
      )}
      <div className={`flex-1 ${flexDir ? "w-2/3" : ""}`}>
        <NumericTextBox
          placeholder={placeholder}
          name={name}
          onChange={handleChange}
          disabled={disabled}
          value={value}
          valid={isValid}
          onBlur={() => setDirty(true)}
          min={0}
          spinners={false}
        />
        {required && dirty && (value === null || value === undefined) && (
          <ErrorMessage message="*Field can't be empty." />
        )}
      </div>
    </div>
  );
}

export default BBSNumberField;
